module.exports = __webpack_public_path__ + "b2754e032a16237ffa3f420f8cbc83c5.jpg";